import React from 'react';

export default function AdminEmailForwardingSection({ appId }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <span>↪️</span>
          <span>Email Forwarding</span>
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Email forwarding for legal and support contact addresses
        </p>
      </div>

      <div className="space-y-4">
        <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
          <p className="text-sm text-gray-700 mb-3">
            Use email forwarding to receive messages sent to addresses like{' '}
            <code className="text-xs bg-gray-200 px-1.5 py-0.5 rounded">privacy@yourdomain.com</code> or{' '}
            <code className="text-xs bg-gray-200 px-1.5 py-0.5 rounded">terms@yourdomain.com</code>.
            Commonly used for privacy policy and terms & conditions contact addresses displayed in your app's footer.
          </p>
          <p className="text-xs text-gray-600 mb-4">
            ImprovMX is available for this organisation. Set up a domain, create aliases, and forward to your real inbox.
          </p>
          <a
            href="https://app.improvmx.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-zapt-purple rounded-lg hover:bg-zapt-purple/90 transition-colors"
          >
            Open ImprovMX →
          </a>
        </div>
      </div>
    </div>
  );
}
